<template>
    <client-page>
        <sub-visual sh="시설 및 참여" tabActive="시설소개" bg="/images/sub/visual/sv2.jpg"> </sub-visual>

        <section class="section">
            <v-container>
                <dept3-tab page="시설소개" tabActive="4" />

                <div class="tit-wrap">
                    <h3 class="tit font-weight-bold">왓베이스볼18.44파크몰</h3>
                </div>

                <div class="mb-50 mb-lg-80">
                    <center-top sc1="실제 마운드와 같은 18.44m, 오차 없는 거리에서 즐기는 리얼 타격 경험." sc2="최신 시설과 압도적 공간감, 유소년부터 성인까지 모두 즐기는 프리미엄 배팅장.">
                        <slide-primary slideNum="1" className="pagination-top">
                            <div v-for="(image, index) in images" :key="index" class="swiper-slide">
                                <img :src="image" alt="" class="d-block w-100" />
                            </div>
                        </slide-primary>
                    </center-top>
                </div>

                <div class="mb-50 mb-lg-80">
                    <v-row>
                        <v-col v-for="(item, index) in items" :key="index" cols="12" sm="6" lg="3" class="mb-10 mb-lg-0">
                            <num-item :num="`0${index + 1}`">
                                <icon-primary className="mb-10 mb-lg-20" :icon="item.icon" maxWidth="40" />
                                <p class="page-text page-text--sm" v-html="item.text" />
                            </num-item>
                        </v-col>
                    </v-row>
                </div>

                <div class="mb-50 mb-lg-74 w-100">
                    <v-img src="/images/sub/center/whatbaseball/map.jpg" class="w-100"></v-img>
                </div>

                <h5 class="tit--sm font-weight-bold mb-10 mb-lg-26">찾아 오시는 길</h5>

                <div class="pa-20 pa-ma-30 pa-lg-50 border border-color-light border-2 border-lg-4">
                    <div class="d-lg-flex align-center mb-12 mb-lg-20">
                        <p class="w-60px w-lg-100px py-4 page-text text-center bg-secon color-white mb-2 mb-lg-0 mr-12 mr-lg-40 font-weight-bold">주소</p>
                        <p class="color-grey page-text">경기도 파주시 상지석길 184 왓베이스볼 18.44 파크몰</p>
                    </div>
                    <div class="d-lg-flex align-center">
                        <p class="w-60px w-lg-100px py-4 page-text text-center bg-secon color-white mb-2 mb-lg-0 mr-12 mr-lg-40 font-weight-bold">대중교통</p>
                        <div class="d-lg-flex align-center page-text">
                            <div class="d-flex">
                                <p class="font-weight-bold w-40px w-lg-auto mr-4 mr-lg-14">버스</p>
                                <div class="d-flex align-center">
                                    <!-- <span class="dot mr-2 mr-lg-4" style="background-color: #4b80ea"></span> -->
                                    <span class="dot mr-4 mr-lg-10" style="background-color: #f2a900" />
                                    <p class="color-grey">089 ‘운정역’ → ‘그린씨티동문아파트 고작골’ 하차</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import Dept3Tab from "@/components/client/ko/sub/dept3-tab.vue";
import NumItem from "@/components/client/ko/sub/sub-num-item.vue";
import SlidePrimary from "@/components/client/ko/sub/sub-slide-primary.vue";
import CenterTop from "@/components/client/ko/sub/sub-center-top.vue";
import IconPrimary from "@/components/client/ko/sub/sub-icon-primary.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        Dept3Tab,
        NumItem,
        SlidePrimary,
        CenterTop,
        IconPrimary,
    },
    data() {
        return {
            images: [
                "/images/sub/center/whatbaseball/s1-img1.jpg",
                "/images/sub/center/whatbaseball/s1-img2.jpg",
                "/images/sub/center/whatbaseball/s1-img3.jpg",
                "/images/sub/center/whatbaseball/s1-img4.jpg",
                //
            ],
            items: [
                {
                    icon: "/images/sub/center/whatbaseball/s1-icon1.svg",
                    text: "전국 최고 수준 층고로 타구 궤적 직접 확인 가능, 실제 마운드와 동일한 18.44m 거리 설계.",
                },
                {
                    icon: "/images/sub/center/whatbaseball/s1-icon2.svg",
                    text: "아이들을 위한 맞춤 타격 거리 제공 <br class='d-none d-lg-block'>+ 무료 타격 영상 녹화· 다운로드 서비스",
                },
                {
                    icon: "/images/sub/center/whatbaseball/s1-icon3.svg",
                    text: "유료 운영(30분/2인 기준) ·<br class='d-none d-lg-block'>네이버 예약 필수, 개인·팀 훈련 <br class='d-none d-lg-block'>모두 가능",
                },
                {
                    icon: "/images/sub/center/whatbaseball/s1-icon4.svg",
                    text: "내야 수비 연습 및 팀 대관까지 가능→단체 훈련/개인 연습 모두 충족",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
</style>
